import { AxiosResponse } from 'axios';
import api from './';
import { SubscriptionResponse } from './types/billing';

const createStripeSubscriptionSession = async () => {
  return await api.post<
    object,
    AxiosResponse<{
      url: string;
    }>
  >(
    '/billing/subscription/session',
    {},
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

const createStripeCustomerSession = async () => {
  return await api.post<object, AxiosResponse<{ secret: string }>>('/billing/customer/session', {});
};

const createStripeSubscriptionSessionForTier = async (tier: string) => {
  return await api.post<
    { tier: string },
    AxiosResponse<{
      url: string;
    }>
  >(
    '/billing/subscription/session',
    { tier },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

const getSubscriptionInfo = async () => {
  return await api.get<SubscriptionResponse>('/billing/subscription');
};

const syncFeatureFlags = async (userId: string) => {
  return await api.post<{ userId: string }, AxiosResponse<{ success: boolean; message: string }>>(
    '/users/sync-feature-flags',
    { userId }
  );
};

const BillingApi = {
  createStripeSubscriptionSession,
  createStripeCustomerSession,
  createStripeSubscriptionSessionForTier,
  getSubscriptionInfo,
  syncFeatureFlags
};

export default BillingApi;
